import React, { useState, forwardRef, useEffect } from 'react'
import {
  // useAppEx,
  useTbViewStore,
  // useProcessStore,
  // useDetailStore,
} from '@vt/hooks'
// import { fetchTableData } from '@vt/apis/lib-ex/v2/tables'
import { pick } from 'lodash-es'

import NodeContent from './nodeContent'
import FormContent from './formContent'

const Content = function ({ onClickSubmitProcess, detailFormRef }, ref) {
  // const { appId } = useAppEx()
  const [showContent, setShowContent] = useState('node')
  const { tbId, setRefreshStatus } = useTbViewStore((state) =>
    pick(state, ['tbId', 'setRefreshStatus'])
  )

  // const { data } = useProcessStore((state) => pick(state, ['data']))
  // const { setCurrentData } = useDetailStore((state) =>
  //   pick(state, ['setCurrentData'])
  // )

  // 重新查询当前案件信息(这里不需要了，更新数据再tbViewStore 里面处理了)
  // const setDataById = () => {
  //   return new Promise((resolve) => {
  //     fetchTableData(
  //       appId,
  //       tbId,
  //       {
  //         filters: {
  //           logicType: 'and',
  //           queries: [
  //             {
  //               slug: 'tableDataId',
  //               queryType: 'equal',
  //               value: data.tableDataId,
  //             },
  //           ],
  //         },
  //       },
  //       { size: 1, page: 0 }
  //     ).then((result) => {
  //       if (result.tbData && result.tbData.length) {
  //         // setCurrentData(result.tbData[0])
  //         onClickSubmitProcess(result.tbData[0])
  //       } else {
  //         fetchTbData()
  //         close()
  //       }
  //       resolve()
  //     })
  //   })
  // }

  useEffect(() => {
    if (setRefreshStatus) {
      setRefreshStatus(false)
    }
  }, [])

  return (
    <div style={{ borderTop: '1px solid #e7e7e7' }}>
      {showContent === 'node' ? (
        <NodeContent
          setShowContent={setShowContent}
          setDataById={onClickSubmitProcess}
        />
      ) : (
        <FormContent
          ref={ref}
          setShowContent={setShowContent}
          setDataById={onClickSubmitProcess}
          tbId={tbId}
          detailFormRef={detailFormRef}
        />
      )}
    </div>
  )
}

export default forwardRef(Content)
